// Claude API integration for generating speech summaries via proxy server

export async function generateSpeechSummary(speeches, customPrompt = '') {
  if (!speeches || speeches.length === 0) {
    return "No speeches available to summarize.";
  }

  try {
    // Determine the correct API endpoint based on environment
    let apiEndpoint;
    if (process.env.REACT_APP_API_URL) {
      // Use custom API URL if set
      apiEndpoint = `${process.env.REACT_APP_API_URL}/api/generate-summary`;
    } else if (process.env.NODE_ENV === 'production') {
      // In production (Vercel), use relative path
      apiEndpoint = '/api/generate-summary';
    } else {
      // In development, use localhost Express server
      apiEndpoint = 'http://localhost:3001/api/generate-summary';
    }
    
    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ speeches, customPrompt })
    });

    if (!response.ok) {
      const responseText = await response.text();
      console.error('API error response:', responseText);
      
      try {
        const errorData = JSON.parse(responseText);
        return `Error generating summary: ${errorData.error || 'Unknown error'}`;
      } catch (parseError) {
        return `Error generating summary: Server returned ${response.status} - ${responseText.substring(0, 100)}...`;
      }
    }

    const responseText = await response.text();
    
    try {
      const data = JSON.parse(responseText);
      return data.summary;
    } catch (parseError) {
      console.error('Failed to parse JSON response:', parseError);
      return `Error: Invalid response format - ${responseText.substring(0, 100)}...`;
    }
  } catch (error) {
    console.error('Error calling summary API:', error);
    return `Error generating summary: ${error.message}`;
  }
}
